import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {Link} from 'react-router-dom'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import Alert from '@material-ui/lab/Alert';
import swal from 'sweetalert'
import i18n from "i18next";
import './Login.css';
import Spinner from '../../../components/Spinner/Spinner';
import * as actionCreators from '../../../store/actions/index';
import axios from '../../../http-config';
import { combineReducers } from 'redux';
import { withTranslation } from 'react-i18next';


class Login extends Component {
  constructor(props){
  super(props)
      this.state = {
        lang : "english",
        value: "en",
        isPasswordShown: false,
        emailError:"",
        passwordError:"",
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Your Email'
                },
                value: '',
                validation: {
                    required: true,
                },
                isValid: false,
                touched: false,
                label: 'Email'
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Your password'
                },
                value: '',
                validation: {
                    required: true,
                },
                isValid: false,
                touched: false,
                label: 'Password'
            }
        }
    }
  }

  

    inputChangedHadler = (event, controlName) => 
    {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                // isValid: this.checkValidity(event.target.value, this.state.controls[controlName].validation),
                touched: true
            }
        }
        this.setState({ controls: updatedControls }, ()=>
        {
           this.checkValidity()
        });
    }

    checkValidity(value, rules) {
      const { t, i18n } = this.props;
        let isError=false;
        if(!this.state.controls.email.value)
        {
          isError=true;
          // this.setState({emailError:"*Email/Username cannot be blank"})
          this.setState({emailError:`${t("emailError1")}`})                   //Login using username only
        }
        // if(this.state.controls.email.value.includes('@'))
        // {
          // var mailformat= /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
          // if(!this.state.controls.email.value.match(mailformat))
          // {
          //   isError=true;
          //   this.setState({emailError:"*You have entered an invalid email address"})
          // }
          // else if(this.state.controls.email.value.match(mailformat))
          // {
          //   this.setState({emailError:''})
          // }
        // }
        if(this.state.controls.email.value)
        {
          if(this.state.controls.email.value.length>0 && this.state.controls.email.value.length<3)
          {
            isError=true;
            this.setState({emailError:`${t("emailError2")}`})
          }
          else if(this.state.controls.email.value.length>0 && this.state.controls.email.value.length>=3)
          {
            this.setState({emailError:""})
          }
        }
        if(!this.state.controls.password.value){
          isError=true;
          this.setState({passwordError: `${t("password1")}`})
        }
        else if(this.state.controls.password.value.length >0 && this.state.controls.password.value.length < 8 ) 
        {
            isError=true;
            this.setState({passwordError:`${t("password2")}`})
        }
        else if(this.state.controls.password.value.length>7 && this.state.controls.password.value.search(/[0-9]/)==-1)
        {
            isError=true;
            this.setState({passwordError:`${t("password3")}`})
        }
        else if(this.state.controls.password.value.length>7 && this.state.controls.password.value.search(/[a-z]/)==-1)
        {
            isError=true;
            this.setState({passwordError:`${t("password4")}`})
        }
        else if(this.state.controls.password.value.length>7 && this.state.controls.password.value.search(/[A-Z]/)==-1)
        {
            isError=true;
            this.setState({passwordError:`${t("password5")}`})
        }
        else if(this.state.controls.password.value.length>7 && this.state.controls.password.value.search(/[!/@/#/%/^/&/*/(/)/_/-/+/=/</>/,/./|/]/)==-1)
        {
            isError=true;
            this.setState({passwordError: `${t("password6")}`})
        }
        else
        {
          this.setState({passwordError:""})
        }
       return isError

    }

    loginHandler = (event) => 
    
    {
      const { t, i18n } = this.props;
      event.preventDefault();
      const err=this.checkValidity()
      if(!err){
      const email = this.state.controls.email.value;
      const password = this.state.controls.password.value;
      this.props.onLoginSubmit(email, password, t);
      }
    }

    redirectToResetPassword = (event) => {
      const {t, i18n} = this.props
      event.preventDefault();
      const email = this.state.controls.email.value;
      if (email) {
        let url = '/otp';
        axios.post(url, {email: email}).then((response) => {
          this.props.history.push('/reset_password');
          localStorage.setItem('email', email);
        }).catch(err => {
          // swal("Invalid Email Address/User name")
          swal(t("invaliduser"))            //Login using username only
        })
      } else {
        // swal("Please enter username/email to reset password.")
        swal(t('emptyuser'))      //Login using username only
      }
    }


    toggleVisibility=()=>{
      const{isPasswordShown}=this.state
      this.setState({isPasswordShown:!isPasswordShown})
    }
    handleChange = (e) =>
    {
       const lang = e.target.value
       this.setState({lang : lang})
    }


    render() {
      const { t, i18n } = this.props;
        let form =(
          <div className="modal_page">              
            <div className="modal_right">
              <div className="modal-CloseBtn">
                 <button className="cancel-button" onClick={() => this.props.OpenModal(false)}>X</button>
              </div>
            
              <h4>Log in</h4>
             
              <form onSubmit={this.loginHandler}>
                <div className="modal_form">
                  <FormControl>
                    {/* <label>Email Address / User Name</label> */}    
                    <label >{t("")}</label> 
                    < OutlinedInput borderColor="green" onChange={(event) => this.inputChangedHadler(event, 'email')}  placeholder="User Name" errortext={this.state.emailError} />
                    <div style={{fontSize:12,color:"red"}}>{this.state.emailError}</div>   
                  </FormControl>
                  <br/>
                  <br/>
                  <div className="form-group">
                    <FormControl>
                      {/* <label >{t('password')}</label> */}
                      <OutlinedInput
                        onChange={(event) => this.inputChangedHadler(event, 'password')}
                        id="standard-adornment-password"
                        type={this.state.isPasswordShown ? "text" : "password"}
                        placeholder="Password"
                        endAdornment={this.state.isPasswordShown ?
                          (<InputAdornment position="end"><VisibilityOffOutlinedIcon onClick={()=>{this.toggleVisibility()}}/></InputAdornment>) :
                          (<InputAdornment position="end">
                              <IconButton
                              aria-label="toggle password visibility"
                              onClick={()=>{this.toggleVisibility()}}>
                              <img src="images/eye.svg" />
                          </IconButton> </InputAdornment> )    
                          }
                          errortext={this.state.passwordError}    
                      />
                       <div style={{fontSize:12,color:"red"}}>{this.state.passwordError}</div>   
                      <div className="login_new_password">
                        {/* <Link to='{`${process.env.PUBLIC_URL}/reset-password`} '> */}
                          <span onClick={this.redirectToResetPassword}>
                            {t('createnew')}
                          </span>
                          {/* </Link> */}
                      </div>
                    </FormControl>
                  </div>
                  <Button type="submit" style={{backgroundColor:"rgb(64, 160, 64) ", marginTop:45 , width:250 }} variant="contained" color="primary">{t("login")}</Button>
                  </div>
              </form>
            
              {/* <FormControl component="fieldset" className="login_options">
                <RadioGroup aria-label="language" name="language" value={this.state.lang} onChange ={this.handleChange}>
                  <FormControlLabel value="english" control={<Radio />} label="English" />
                  <FormControlLabel value="tamil" control={<Radio />} label="தமிழ்" />
                </RadioGroup>
              </FormControl> */}

              {/* <p>&copy; {new Date().getFullYear()} FSSM. All rights reserved.</p> */}
              {/* <p>&copy; 2020 FSSM. All rights reserved. Cookie Preferences, Privacy and Terms.</p> */}
              {/* <p>Powered By Transerve Technologies Private Limited</p> */}
            </div>
          </div>
        ); 

        if (this.props.loading) {
            form = <Spinner />
        }

        let authRedirect = null;
        if (this.props.isAuthenticated) {
            if(process.env.NODE_ENV == "production"){
              authRedirect = <Redirect to='/' />
            }else{
              authRedirect = <Redirect to='/fssm' />
            }
        }
 
        let error = null;
        if (this.props.error) {
            error = (
            <Alert severity="error">{this.props.error[0].message}</Alert>
            )
        }

        return(
            <Container>
                <Row>
                    <Col md={{ span: 6, offset: 3 }}>
                        {error}
                        {authRedirect}
                        {form}
                    </Col>
                </Row>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLoginSubmit: (email, password, t) => dispatch(actionCreators.auth(email, password, t)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));